import * as z from "zod";

import Limits from "../_const/Limits.ts";
import { allDateFlexibility } from "../_const/trip/DateFlexibility.ts";
import { allSpecialReasonForTrip } from "../_const/trip/SpecialReasonForTrip.ts";
import { allTripPlanningTypes } from "../_const/trip/TripPlanningType.ts";
import { allWhoIsJoining } from "../_const/trip/WhoIsJoining.ts";
import { allBookingType } from "../_const/trip/WhatHasBeenBookedType.ts";
import { allFixedBookingCategory } from "../_const/trip/FixedBookingCategory.ts";

export const whatHasBeenBooked = z.object({
  id: z.string().optional(),
  bookingType: z.enum(allBookingType),
  category: z.enum(allFixedBookingCategory).optional(),
  provider: z.string().optional(),
  departureProvider: z.string().optional(),
  dateTime: z.string().optional(),
  location: z.string().optional(),
  departureLocation: z.string().optional(),
  bookingRef: z.string().optional(),
  end: z.string().optional(),
  notes: z.string().optional(),
});

export type WhatHasBeenBooked = z.infer<typeof whatHasBeenBooked>;

export const tripCreateSchema = z.object({
  trip_planning_type: z.enum(allTripPlanningTypes),
  trip_destination: z.string().trim().nullable().optional(),
  trip_destination_place_id: z.string().trim().min(1).nullable().optional(),
  trip_mood: z.string().trim().max(1000).nullable().optional(),

  arrival_date: z.string().optional(),
  departure_date: z.string().optional(),
  duration: z.number().int().positive().max(Limits.TRIP_DURATION).optional(),
  can_modify_arrival_or_departure_dates: z.enum(allDateFlexibility),

  who_is_joining: z.enum(allWhoIsJoining),
  what_has_been_booked: z.array(whatHasBeenBooked).optional(),
  number_of_adults: z.number().int().min(1),

  are_there_children: z.boolean(),
  children_ages: z
    .array(z.number().min(1 / 12).max(17))
    .max(6)
    .default([]),

  is_it_special_reason_for_trip: z
    .enum(allSpecialReasonForTrip)
    .optional(),
  special_reason_custom: z.string().trim().max(250).nullable().optional(),

  apply_saved_accessibility_requirements: z.boolean().optional(),
  additional_accessibility_requirements: z
    .string()
    .trim()
    .max(1000)
    .nullable()
    .optional(),

  trip_specific_changes: z
    .string()
    .trim()
    .max(1000)
    .nullable()
    .optional(),

  additional_requests: z.string().optional(),
});

export type TripCreateRequest = z.infer<typeof tripCreateSchema>;
